export function convertStringToArray(value, delimiter = ',') {
    return value.split(delimiter);
}
